const Placeholder = () => 
  import(/* webpackChunkName: 'Placeholder' */ '@/Core/Placeholder');
const TaskIndex = () => 
  import(/* webpackChunkName: 'TaskIndex' */ '@/Tasks/Index');

export default [
  {
    path: '/tasks',
    name: 'tasks',
    component: TaskIndex,
    meta: { auth: true },
    props: route => ({
      page: (Number)(route.query.p || 1),
      statusFilter: route.query.stf,
      teamMemberFilter: route.query.tf,
      sortOrder: route.query.so,
      sortField: route.query.sf,
    }),
  },
  {
    path: '/tasks/scheduled-autopilot',
    name: 'tasks.scheduled-autopilot',
    component: Placeholder,
    meta: { auth: true },
  },
  {
    path: '/tasks/calendar',
    name: 'tasks.calendar',
    component: Placeholder,
    meta: { auth: true },
  },
];
